/* LIORIVE — campaign film band (sections/liorive-film.liquid).
   The file is only requested when the band nears the screen; phones get the 4:5 crop.
   It plays silently while in view and pauses out of view. Reduced motion or data saver: poster only,
   until the visitor presses «Lire». A pause chosen by the visitor is kept. */
(function () {
  if (window.lrFilmReady) return;
  window.lrFilmReady = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saver = navigator.connection && navigator.connection.saveData;

  function setup(root) {
    if (root.dataset.lrFilmInit) return;
    root.dataset.lrFilmInit = '1';
    var video = root.querySelector('video');
    var play = root.querySelector('[data-lr-film-play]');
    var sound = root.querySelector('[data-lr-film-sound]');
    if (!video || !play) return;

    // Page opening under the transparent header (body.lr-overlay-header, homepage and La Maison).
    var header = document.querySelector('.section-header');
    if (root.hasAttribute('data-lr-film-hero') && header && document.body.classList.contains('lr-overlay-header') && root.closest('main > .shopify-section:first-child')) {
      var setH = function () { document.documentElement.style.setProperty('--lr-header-h', header.offsetHeight + 'px'); };
      setH();
      if ('ResizeObserver' in window) new ResizeObserver(setH).observe(header);
      root.classList.add('lr-film--under-header');
    }

    var auto = !still.matches && !saver;
    var userPaused = !auto;
    var inView = false;

    function load() {
      if (video.getAttribute('src')) return;
      video.src = phone.matches ? video.dataset.srcPhone : video.dataset.srcWide;
    }
    function sync() {
      var on = !video.paused;
      play.setAttribute('aria-pressed', on ? 'true' : 'false');
      play.setAttribute('aria-label', on ? 'Mettre le film en pause' : 'Lire le film');
      if (!sound) return;
      sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      sound.setAttribute('aria-label', video.muted ? 'Activer le son' : 'Couper le son');
    }
    function start() {
      load();
      var p = video.play();
      if (p && p.catch) p.catch(function () { userPaused = true; sync(); });
    }

    video.addEventListener('playing', function () { root.classList.add('is-playing'); sync(); });
    video.addEventListener('pause', sync);
    play.hidden = false;
    if (sound) sound.hidden = false;
    sync();

    play.addEventListener('click', function () {
      if (video.paused) { userPaused = false; start(); }
      else { userPaused = true; video.pause(); }
    });
    if (sound) sound.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted && video.paused) { userPaused = false; start(); }
      sync();
    });

    if (!('IntersectionObserver' in window)) {
      if (auto) start();
      return;
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        inView = e.isIntersecting;
        if (inView && !userPaused) start();
        else if (!inView && !video.paused) video.pause();
      });
    }, { rootMargin: '200px 0px' }).observe(root);
  }

  function init() { document.querySelectorAll('[data-lr-film]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
